<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">下单开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.startDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">下单结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.endDate" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">订单号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderNo" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="table" class="full-height display-col">
        <div class="tips">
          <span class="tip-item"> 订单收入总额：{{addThousandSeparator(form.totalIncomeFee)}}元</span>
          <span class="tip-item">采购成本总额（商品费+中国运费）{{addThousandSeparator(form.totalPurchaseCost)}}元</span>
          <span class="tip-item">订单毛利总额 （收入-采购成本）{{addThousandSeparator(form.totalNetFee)}}元</span>
        </div>
        <el-table :data="recordList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" border
          height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column prop="userName" align="center" label="用户ID">
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="下单日期" width="90">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column prop="orderNo" align="center" label="订单号">
          </el-table-column>
          <el-table-column prop="goodsNameCus" align="center" label="品名">
          </el-table-column>
          <el-table-column prop="price" align="center" label="单价">
          </el-table-column>
          <el-table-column prop="goodsCount" align="center" label="数量">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.goodsCount)}}
            </template>
          </el-table-column>
          <el-table-column prop="goodsFee" align="center" label="商品费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.goodsFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="agentServiceFee" align="center" label="代购手续费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.agentServiceFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="commission" align="center" label="手续费:(单价*数量)*5%">
            <template v-slot="scope">
              {{addThousandSeparator(((scope.row.price*scope.row.goodsCount) * 0.05).toFixed(2))}}
            </template>
          </el-table-column>
          <el-table-column prop="inlandFreight" align="center" label="中国运费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.inlandFreight)}}
            </template>
          </el-table-column>
          <el-table-column prop="inspectionFee" align="center" label="检品费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.inspectionFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="labelFee" align="center" label="标签费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.labelFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="categoryPrice" align="center" label="仓库保管费">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.categoryPrice)}}
            </template>
          </el-table-column>
          <el-table-column prop="incomeFee" align="center" label="收入">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.incomeFee)}}
            </template>
          </el-table-column>
          <el-table-column prop="purchaseCost" align="center" label="采购成本">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.purchaseCost)}}
            </template>
          </el-table-column>
          <el-table-column prop="total" align="center" label="毛利">
            <template v-slot="scope">
              {{addThousandSeparator(scope.row.total)}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'orderIncome',
  data () {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1,
        userName:"",
        orderNo:""
      },
      recordList: [],
      total: 0,
      form: {},
    }
  },
  methods: {
    getTime () {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.queryInfo.startDate = year + '-' + month + '-' + '01';
      this.queryInfo.endDate = year + '-' + month + '-' + day;
      this.getrecordList();
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction () {
      this.$http({
        url: '/financial/exportOrderIncome',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '订单收入统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('/financial/queryOrderIncome', { params: this.queryInfo });
      console.log(res,123123456);
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      this.queryInfo.orderNo = ''
      this.queryInfo.userName = ''
       this.queryInfo.endDate= ''
      this.queryInfo.startDate = ''
    },
    async getTool () {
      const { data: res } = await this.$http.get('/financial/queryOrderIncomeHeader', { params: this.queryInfo });
      this.form = res.data
    }
  },
  activated () {
    this.getTime()
  },
  created () {
    this.getTime()
    this.getTool();
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.tips {
  margin: 15px 0;
  text-align: right;
}
.tip-item{
  margin-left: 30px;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
